var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5391,
    y: 15.3999,
    width: 9.24,
    height: 9.24,
    rx: 4.62,
    fill: "#49505E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6207 19.558V17.248H19.6967V19.558H17.3867V20.482H19.6967V22.792H20.6207V20.482H22.9307V19.558H20.6207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8085 12.1689C15.241 12.1689 17.213 10.1969 17.213 7.76436C17.213 5.33182 15.241 3.35986 12.8085 3.35986C10.376 3.35986 8.40402 5.33182 8.40402 7.76436C8.40402 10.1969 10.376 12.1689 12.8085 12.1689ZM3.7793 22.079C3.7793 17.0923 7.82181 13.0497 12.8085 13.0497C14.8084 13.0497 16.6564 13.6999 18.1527 14.8005C15.9895 15.4754 14.4193 17.4943 14.4193 19.8799C14.4193 20.6641 14.589 21.4087 14.8937 22.079H3.7793Z",
    fill: "#49505E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddUser);
export default __webpack_public_path__ + "static/media/icon-add-user.08b4dccab4fc8cf1a149a0f3659ea1fe.svg";
export { ForwardRef as ReactComponent };